/* import __COLOCATED_TEMPLATE__ from './switch.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();